import { Metric } from 'web-vitals'
import Analytics from './services/analytics'

// event values can only contain integers
function getEventValueFromMetric(metric: Metric) {
  if (metric.name === 'CLS') {
    return Math.round(metric.value * 1000)
  }
  return Math.round(metric.value)
}

export function reportHandler(metric: Metric) {
  Analytics.push({
    dataLayer: {
      event: 'Web Vitals',
      eventAction: metric.name,
      eventValue: getEventValueFromMetric(metric),
      eventLabel: metric.id,
      nonInteraction: true,
      data: metric,
    },
  })
}
